import { observer } from 'mobx-react-lite'
import { useContext } from 'react'
import { Box, EnumHelperText, HelperText, Typography, Warning } from 'shared/ui'
import { makeTextFieldHighlightLimit, TextField } from 'shared/ui/TextField'
import { MAX_COMPANY_NAME_LENGTH } from 'shared/constants/auth'
import { DoubleOptInPageContext } from 'pages/settings/pages/doubleOptIn/context/doubleOptInContext'
import styles from './styles.module.scss'

export const DoubleOptInSettingCompanyName = observer(
  ({ title, description }: { title: string; description?: string }) => {
    const store = useContext(DoubleOptInPageContext)
    if (!store) return null

    const { companyName, setCompanyName, updateCompanyName, limitReached, setLimitReached } = store

    return (
      <div className={styles.item}>
        <div className={styles.infoWrap}>
          <Box display={'flex'} alignItems={'center'} gap={'6px'}>
            <Typography
              ariaLabel='title'
              variant='body-md-medium'
              color='var(--content-primary-primary)'
            >
              {title}
            </Typography>
          </Box>
          <div className={styles.description}>{description}</div>
        </div>
        <div className={styles.inputWrap}>
          <TextField
            variant='stroke'
            size='medium'
            value={companyName}
            error={!companyName}
            onBlur={updateCompanyName}
            onChange={setCompanyName}
            mainActions={[
              makeTextFieldHighlightLimit({
                limit: MAX_COMPANY_NAME_LENGTH,
                onChange: setLimitReached,
              }),
            ]}
          />
          <div style={{ paddingTop: '4px' }}>
            {!companyName && (
              <HelperText
                icon={'alertTriangleSmall'}
                variant={EnumHelperText.Error}
                text={'Please enter a company name'}
              />
            )}
            {limitReached && (
              <Warning text={`${MAX_COMPANY_NAME_LENGTH}-character limit reached`} />
            )}
          </div>
        </div>
      </div>
    )
  }
)
